import { Grid } from "@dhx/ts-grid";
import { cleanActionConfig, getCellIds } from "../helpers/main";
import { Actions, IAction, IActionConfig, SpreadsheetEvents } from "../types";

export class ResizeRow implements IAction {
	public config: IActionConfig;
	private _prevRows: any[];
	private _rowsAfterResize: any[];

	constructor(config: IActionConfig) {
		this.config = config;
	}

	do() {
		const { grid, cell, mouseEvent } = this.config;

		if (this._rowsAfterResize) {
			this._rowsAfterResize.forEach(row => {
				const { id, height } = row;
				grid.data.update(id, { height, changedByUser: true });
			});
			return;
		}
		const initY = mouseEvent.clientY;
		const [startCell, endCell] = cell.split(":");
		const first = getCellIds(startCell, grid);
		const last = getCellIds(endCell || startCell, grid);
		const rowsCopy = [...grid.data.serialize()];
		const node = (grid as Grid).getRootNode();
		node.style.cursor = "row-resize";
		let selectedRows = [];

		for (let i = first.row; i <= last.row; i++) {
			const row = rowsCopy.find(item => (+item.id - 1) === i);
			if (!row) continue;
			if (!row.height) {
				(row as any).height = grid.config.rowHeight;
			}
			selectedRows.push(row);
		}
		this._prevRows = selectedRows.map(r => ({ ...r }));
		this._rowsAfterResize = selectedRows.map(r => ({ ...r }));
		const moveHandler = e => {
			const move = e.clientY - initY;
			selectedRows.forEach(row => {
				const size = row.height + move / selectedRows.length;
				const height = size <= 10 ? 10 : size;
				grid.data.update(row.id, { height, changedByUser: true });
				this._rowsAfterResize.find(r => r.id === row.id).height = height;
			});
			grid.paint();
		};

		const upHandler = e => {
			document.removeEventListener("mousemove", moveHandler);
			document.removeEventListener("mouseup", upHandler);
			node.style.cursor = "unset";
			this.config.spreadsheet.events.fire(SpreadsheetEvents.afterAction, [
				Actions.resizeRow,
				cleanActionConfig(this.config),
			]);
		};
		document.addEventListener("mousemove", moveHandler);
		document.addEventListener("mouseup", upHandler);
		grid.paint();
	}

	undo() {
		this._prevRows.forEach(row => {
			const { id, height } = row;
			this.config.grid.data.update(id, { height, changedByUser: true });
		});
	}
}
